import {boot} from 'quasar/wrappers';

export default boot(async () => {
  const {register} = await import('swiper/element/bundle');
  register();
})
